import { ContainerTabs, ListTabs } from "./styled";
import { useState } from "react";
import { gerarKey, isDisabled } from "./meta";

//PROPS
interface Props {
    label?: string;
    tabs: {icone: any, cod_id?: number, descricao: string, disabled?: boolean, disabledMsg?: string, task?: Function, width?: number}[];
    selecionado: string | number;
    onChangeId?: Function;
    onChange: Function;
    repetir?: Function;
    indexInicial?: number;
    disableAll?: boolean;
    width?: string | number;
    tab_key?:string
    trackWidth?: number;
    useTabWidth?: boolean;
    apenasIcones?: boolean;
}

const TabsRadio: React.FC<Props> = ({ label, tabs, selecionado, onChange, repetir, 
    indexInicial, disableAll, trackWidth, width, tab_key, useTabWidth, apenasIcones, onChangeId }) => {

    //STATES
    const [indexSelecionado, setIndexSelecionado] = useState<number>(indexInicial ?? 0);

    function obterLarguras() {

        if (apenasIcones) {
            return 60 * indexSelecionado;
        }

        let tabs_anteriores = tabs?.filter((_, index)=> index < indexSelecionado);
        let larguras = tabs_anteriores?.map(item=> item.width);
        let soma: number = larguras.reduce((acumulador, valorAtual) => {
            return acumulador + valorAtual;
          }, 0);
          
        return soma ?? 0;
    }

    function larguraTrack(): number {
        if (apenasIcones) {
            return 60;
        }
        return tabs?.[indexSelecionado??0]?.width ?? trackWidth;
    }

    return (
        <ContainerTabs style={{width: width}}>
            {!!label &&(
                <label className="ContainerTabs__label">
                    {label}
                </label>
            )}
            
            <ListTabs trackWidth={useTabWidth ? obterLarguras() : (tabs?.[indexSelecionado - 1]?.width ?? trackWidth) ?? 173} data-disabled={disableAll}>
                {tabs.map(({ icone, cod_id, descricao, task, disabled, disabledMsg, width }, index)=> {
                    return (
                        <button 
                            key={gerarKey(index)} 
                            type="button" 
                            className="ListTabs__tab" 
                            id={!!tab_key ? `btnTab_${tab_key}_${index}` : `btnTab${index}`}
                            data-active={selecionado === descricao}
                            data-only-icon={(apenasIcones)??false}
                            value={selecionado} 
                            name={descricao}
                            onClick={()=>{setIndexSelecionado(index);onChange(descricao);task?.();repetir?.(descricao);onChangeId?.(cod_id)}}
                            disabled={disableAll ? true : Boolean(disabled)}
                            style={{width: width ?? trackWidth, minWidth: width ?? trackWidth}}
                            title={isDisabled(disableAll, disabled) ? (disabledMsg ?? 'Elemento não possui mapa distribuído') : descricao}
                        >
                            <div className="ListTabs__tab__icon">
                                <img src={icone} />
                            </div>
                            
                            <span className="ListTabs__tab__descr">
                                {descricao}
                            </span>
                            
                        </button>
                    )
                })}
                {useTabWidth
                    ?  <div className={`tab__highlight_float ${disableAll?"disabled":''}`} style={{width: larguraTrack()}} data-position={indexSelecionado} data-apenas-icone={apenasIcones??false} />
                    :  <div className={`tab__highlight ${disableAll?"disabled":''}`} style={{width: larguraTrack()}} data-position={indexSelecionado} data-apenas-icone={apenasIcones??false} />
                }
            </ListTabs>
        </ContainerTabs>
    )
};

export default TabsRadio;